import { formatDateReplaceHour } from 'src/utils/formatDate'
import { FieldPath, FieldValues, UseFormRegister } from 'react-hook-form'
import { Typography } from '@mui/material'
import SimpleInput from '../SimpleInput/SimpleInput'
import * as S from './FormBatchQuantity.styles'

interface FormBatchQuantityProps<T extends FieldValues, K extends FieldPath<T>> {
  register: UseFormRegister<T>;
  inputName: K;
  quantity: number;
  expirationDate: Date;
  dataTestId: string;
  hasError: boolean;
  errorMessage?: string
  useInput?: boolean
  countedQuantity?: number
  productDueDateType?: string
}

const FormBatchQuantity = <T extends FieldValues, K extends FieldPath<T>>(
  props: FormBatchQuantityProps<T, K>,
) => {
  const {
    register,
    inputName,
    quantity,
    expirationDate,
    dataTestId,
    hasError,
    errorMessage,
    useInput = true,
    countedQuantity,
    productDueDateType,
  } = props

  return (
    <S.Container>
      <S.ContainerItem>
        <S.ContainerLabel>
          Separar:
        </S.ContainerLabel>
        <S.ContainerValue>
          {quantity}
        </S.ContainerValue>
      </S.ContainerItem>
      <S.ContainerItem>
        <S.ContainerLabel>
          {useInput ? 'Validade:' : 'Val. Min.:'}
        </S.ContainerLabel>
        <S.ContainerValue>
          {productDueDateType === 'LONG_DURATION' ? formatDateReplaceHour(expirationDate, false) : formatDateReplaceHour(expirationDate, true)}
        </S.ContainerValue>
      </S.ContainerItem>
      <S.ContainerItem>
        <S.ContainerLabel>
          Separado:
        </S.ContainerLabel>
        <S.ContainerValue>
          {useInput ? (
            <SimpleInput
              register={register}
              inputName={inputName}
              dataTestId={dataTestId}
            />
          ) : countedQuantity}
        </S.ContainerValue>
      </S.ContainerItem>
      {
        hasError && (
          <Typography
            color='red'
            variant='caption'
          >
            {errorMessage}
          </Typography>
        )
      }
    </S.Container>
  )
}

export default FormBatchQuantity
